import { render } from "./PolicyFormTrackers.vue?vue&type=template&id=4d6beaaa&ts=true"
import script from "./PolicyFormTrackers.vue?vue&type=script&lang=ts"
export * from "./PolicyFormTrackers.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PolicyFormTrackers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6beaaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6beaaa', __exports__)) {
    api.reload('4d6beaaa', __exports__)
  }
  
  module.hot.accept("./PolicyFormTrackers.vue?vue&type=template&id=4d6beaaa&ts=true", () => {
    api.rerender('4d6beaaa', render)
  })

}


export default __exports__